import queryString from 'query-string'

export const getUrlQueryParams = (location: any) => {
    let searchQuery = ''
    if (location.search) {
        const parsedUrlParams = queryString.parse(location.search)
        let { query } = parsedUrlParams

        if (Array.isArray(query)) {
            query = query.filter(q => q !== null).join(' ')
        }

        searchQuery = query || searchQuery
    }
    return {
        searchQuery: searchQuery,
    }
}
